import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Layout from "../Common/Layout";
import PestControlList from "./PestControlList";

const PasteControl = () => {
  const [reloadList, setReloadList] = useState(false);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    serialNo: "",
    companyName: "",
    stack: "",
    lastPestControlDate: "",
    nextPestControlDate: "",
    remarks: "",
  });

  useEffect(() => {
    generateSerialNo();
  }, [reloadList]);

  const generateSerialNo = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await fetch(
        "https://irc.zentelex.com/api/pest-control/pest-controls",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await res.json();

      if (!result.success || !result.data) return;

      const serialNumbers = result.data.map((item) => item.serialNo);

      // Extract numeric part from KS-XXXX
      const numbers = serialNumbers
        .filter((sn) => sn.startsWith("KS-"))
        .map((sn) => parseInt(sn.split("-")[1]))
        .filter((num) => !isNaN(num));

      let nextNumber = 1000; // default start

      if (numbers.length > 0) {
        nextNumber = Math.max(...numbers) + 1;
      }

      const newSerial = `KS-${nextNumber}`;

      setFormData((prev) => ({
        ...prev,
        serialNo: newSerial,
      }));
    } catch (error) {
      console.error("Serial No Generation Error:", error);
    }
  };

  const [slipFile, setSlipFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setSlipFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = sessionStorage.getItem("token");
    if (!token) {
      toast.error("Unauthorized! Please login again.");
      return;
    }

    const payload = new FormData();
    payload.append("serialNo", formData.serialNo);
    payload.append("companyName", formData.companyName);
    payload.append("stack", formData.stack);

    payload.append("lastPestControlDate", formData.lastPestControlDate);
    payload.append("nextPestControlDate", formData.nextPestControlDate);
    payload.append("remarks", formData.remarks);

    if (slipFile) {
      payload.append("pestControlSlip", slipFile);
    }

    try {
      setLoading(true);

      const response = await fetch("https://irc.zentelex.com/api/pest-control", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: payload,
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("✅ Pest Control record saved successfully!", {
          autoClose: 1500,
          theme: "colored",
        });

        setReloadList((prev) => !prev);

        // setTimeout(() => {
        //   navigate("/paste-control-report");
        // }, 1500);
      } else {
        toast.error(data.message || "❌ Failed to save record");
      }
    } catch (error) {
      console.error("Pest Control Error:", error);
      toast.error("❌ Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Layout>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <h4 className="page-title">Pest Control</h4>
                    <div className="text-center">
                      <Link
                        style={{ color: "white" }}
                        to="/dashboard"
                        className="btn btn-primary"
                      >
                        Dashboard
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* FORM */}
              <div className="row justify-content-center mt-4">
                <div className="col-xxl-6 col-lg-8 col-md-10">
                  <div className="card shadow-sm border-0 rounded-3">
                    <div
                      className="card-body rounded-4 p-4"
                      style={{ backgroundColor: "#3075A6" }}
                    >
                      <h4
                        className="card-title mb-4 text-center fw-semibold "
                        style={{ color: "white" }}
                      >
                        Pest Control
                      </h4>

                      <form onSubmit={handleSubmit}>
                        {/* Serial No */}
                        <div className="mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Serial No
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="serialNo"
                            value={formData.serialNo}
                            readOnly // 🔥 prevent manual editing
                          />
                        </div>

                        {/* Company Name */}
                        <div className="mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Company Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            {/* Last Pest Control */}
                            <div className="mb-3">
                              <label
                                className="form-label fw-semibold"
                                style={{ color: "white" }}
                              >
                                Last Pest Control
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                name="lastPestControlDate"
                                value={formData.lastPestControlDate}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            {/* Upload Slip */}
                            <div className="mb-3">
                              <label
                                className="form-label fw-semibold"
                                style={{ color: "white" }}
                              >
                                Upload Slip
                              </label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={handleFileChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              Stack
                            </label>
                            <input
                              type="text"
                              name="stack"
                              value={formData.stack}
                              onChange={handleChange}
                              className="form-control"
                              placeholder="Enter stack quantity"
                              required
                            />
                          </div>
                        </div>

                        {/* Remarks */}
                        <div className="mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Remarks
                          </label>
                          <textarea
                            className="form-control"
                            rows="2"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Submit */}
                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn px-5 py-2 fw-semibold"
                            style={{
                              backgroundColor: "#EC662C",
                              color: "white",
                            }}
                            disabled={loading}
                          >
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <ToastContainer />
            </div>
          </div>
        </div>

        <div>
          <PestControlList reload={reloadList}></PestControlList>
        </div>
      </Layout>
    </>
  );
};

export default PasteControl;
